import React from 'react';
import PropTypes from 'prop-types';

const HrefLangManager = ({ alternates }) => {
	return (
		<>
			{alternates.map((alternate, i) => (
				<link key={i} rel="alternate" hrefLang={alternate[0]} href={alternate[1]} />
			))}
		</>
	);
};

HrefLangManager.propTypes = {
	alternates: PropTypes.arrayOf(PropTypes.array).isRequired,
};

export default HrefLangManager;
